import * as Yup from "yup";
import { form } from "./form";

const {
  formField: { rooms },
} = form;

const validations = Yup.object().shape({
  [rooms.name]: Yup.array()
    .of(Yup.string().trim().min(1, "Room name cannot be empty").required("Room name is required"))
    .min(1, "At least one room is required")
    .required("At least one room is required"),
});

export default validations;
